<template>
  <section class="hero-k" id="hero">
    <!-- Die Begrüßung tippt sich (JS-gated); ohne JS steht statisch "Hallo."
                 Eigene Zeile für das rotierende Wort = nie ein Layout-Sprung darunter. -->
    <h1 aria-label="Gute Gespräche beginnen mit einem Hallo.">
    <span aria-hidden="true">
      <span class="hl1">Gute Gespräche</span>
      <span class="hl2">beginnen mit einem</span>
      <span class="hl3"><span class="grad" id="k-greet">Hallo.</span><span class="k-caret"></span></span>
    </span>
    </h1>
    <p class="k-motto">Jetzt <span class="grad">kostenlos</span> registrieren
      <svg class="k-motto-arrow" viewBox="0 0 18 10" fill="none" stroke="url(#ksg)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M2 2l7 6 7-6" />
      </svg>
    </p>

    <LeadFunnel />

    <div class="k-trust">
      <div class="stack" aria-hidden="true">
        <div class="av a1"></div>
        <div class="av a2"></div>
        <div class="av a3"></div>
        <div class="av a4"></div>
        <div class="av a5"></div>
      </div>
      <div class="txt"><strong>Täglich neue Mitglieder</strong><br>in Deutschland, Österreich und der Schweiz</div>
    </div>

    <QuizDuo />
  </section>
</template>

<script>
import LeadFunnel from './LeadFunnel.vue';
import QuizDuo from './QuizDuo.vue';

export default {
  name: 'KennenlernenHeroSection',
  components: { LeadFunnel, QuizDuo },
};
</script>
